import { z } from "zod";

import { MetadataMergeStrategy } from "../metadata-merge-strategy";
import { MetadataOrderOfApplication } from "../metadata-order-of-application";
import { createPolicyOperatorSchema } from "../utils/create-policy-operator-schema";

export const supersetOfOperator = createPolicyOperatorSchema({
  canBeCombinedWith: ["add", "default", "subset_of", "essential"],
  key: "superset_of",
  mergeStrategy: MetadataMergeStrategy.Union,
  operatorJsonValues: [
    z.array(z.string()),
    // TODO: See how we want to we handle the comparison of objects
    // z.array(z.record(z.string().or(z.number()), z.unknown())),
    z.array(z.number()),
  ],
  orderOfApplication: MetadataOrderOfApplication.AfterSubsetOf,
  parameterJsonValues: [
    z.array(z.string()),
    // TODO: See how we want to we handle the comparison of objects
    // z.array(z.record(z.string().or(z.number()), z.unknown())),
    z.array(z.number()),
  ],
});
